export default "__VITE_ASSET__CmOdwa7d__"